

export class UserLicenseDetailsSelectByIdOutputData implements IUserLicenseDetailsSelectByIdOutputData {
    /** The auto-generated id of the user license details master */
    user_license_id!: number;
    /** The auto-generated id of the user master */
    user_id!: number;
    /** The license issue date with 10 character limit */
    license_issue_date!: string;
    /** The license activation date with 10 character limit */
    license_activation_date!: string;
    /** The license expiry date with 10 character limit */
    license_expiry_date!: string;
    /** The license extended date with 10 character limit */
    license_extend_date!: string;
    /** Expiry message in days */
    show_expiry_message!: number;
    /** The remark with 500 character limit */
    remark!: string;
    /** Manage user license details. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IUserLicenseDetailsSelectByIdOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user_license_id = _data["user_license_id"];
            this.user_id = _data["user_id"];
            this.license_issue_date = _data["license_issue_date"];
            this.license_activation_date = _data["license_activation_date"];
            this.license_expiry_date = _data["license_expiry_date"];
            this.license_extend_date = _data["license_extend_date"];
            this.show_expiry_message = _data["show_expiry_message"];
            this.remark = _data["remark"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UserLicenseDetailsSelectByIdOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new UserLicenseDetailsSelectByIdOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user_license_id"] = this.user_license_id;
        data["user_id"] = this.user_id;
        data["license_issue_date"] = this.license_issue_date;
        data["license_activation_date"] = this.license_activation_date;
        data["license_expiry_date"] = this.license_expiry_date;
        data["license_extend_date"] = this.license_extend_date;
        data["show_expiry_message"] = this.show_expiry_message;
        data["remark"] = this.remark;
        data["status"] = this.status;
        return data; 
    }
}

export interface IUserLicenseDetailsSelectByIdOutputData {
    /** The auto-generated id of the user license details master */
    user_license_id: number;
    /** The auto-generated id of the user master */
    user_id: number;
    /** The license issue date with 10 character limit */
    license_issue_date: string;
    /** The license activation date with 10 character limit */
    license_activation_date: string;
    /** The license expiry date with 10 character limit */
    license_expiry_date: string;
    /** The license extended date with 10 character limit */
    license_extend_date: string;
    /** Expiry message in days */
    show_expiry_message: number;
    /** The remark with 500 character limit */
    remark: string;
    /** Manage user license details. 0 For De-active, 1 For Active */
    status: number;
}

